module.exports = __webpack_public_path__ + "img/Ford-Expedition-2.d8194568.png";